export default __webpack_public_path__ + "static/media/Bike.0b75be29.png";